module.exports = __webpack_public_path__ + "fonts/NimbusSanDOT-Bol.otf";